export const fields = {
  LOGIN: 'login',
  PASSWORD: 'password',
}

export default fields
